import {
  buildDateCreatedWhere,
  type TransferOrderListFilters,
} from '../transfer-order-list-filters/index.js';
import type {
  GetTransferOrdersQueryVariables,
  TransferOrderWhere,
} from '../transfer-order-list-operations.js';
import type { TransferOrderWorkspaceQueue } from '../transfer-order-workspace-queues.js';
import { buildTransferOrderQueueWhere } from './build-transfer-order-queue-where.js';
import { compatibleStatusIds } from './compatible-status-ids.js';
import { transferOrderQueueDefinition } from './transfer-order-queue-definition.js';

export function buildTransferOrderListVariables({
  queue,
  filters,
  now,
}: {
  queue: TransferOrderWorkspaceQueue;
  filters: TransferOrderListFilters;
  now: Date;
}): Pick<GetTransferOrdersQueryVariables, 'where' | 'warehouseId' | 'inTransitMinDays'> {
  const definition = transferOrderQueueDefinition(queue);
  const selectedStatusIds = compatibleStatusIds(queue, filters.statusIds);
  const statusIds = selectedStatusIds.length > 0 ? selectedStatusIds : (definition.statusIds ?? []);
  const where: TransferOrderWhere = { ...buildTransferOrderQueueWhere(queue, now) };
  if (statusIds.length > 0) where.statusId = { in: [...statusIds] };
  if (filters.brandId) where.brandId = { equals: filters.brandId };
  const dateCreated = buildDateCreatedWhere(filters.dateCreated);
  if (dateCreated) where.dateCreated = dateCreated;
  return {
    where: Object.keys(where).length > 0 ? where : undefined,
    warehouseId: filters.warehouseId || undefined,
    inTransitMinDays: definition.inTransitMinDays,
  };
}
